if (!customElements.get('deferred-media-video')) {
  class DeferredMediaVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');

      if (!this.video) return;

      this.shouldAutoplay = this.dataset.autoplay === 'true';
      this.isNearViewport = false;
      this.hasStartedLoading = false;
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => this.handleIntersection(entries),
          {
            rootMargin: '300px 0px',
            threshold: 0,
          }
        );
        this.observer.observe(this);
      } else {
        this.isNearViewport = true;
        this.loadVideo();
        this.playVideo();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.pauseVideo();
    }

    handleIntersection(entries) {
      const entry = entries[0];

      if (!entry) return;

      this.isNearViewport = entry.isIntersecting;

      if (this.isNearViewport) {
        this.loadVideo();
        this.playVideo();
      } else {
        this.pauseVideo();
      }
    }

    loadVideo() {
      if (this.hasStartedLoading) return;

      this.hasStartedLoading = true;
      this.video.preload = 'metadata';
      this.video.load();
    }

    playVideo() {
      if (!this.shouldAutoplay || document.hidden) return;

      const playPromise = this.video.play();

      if (playPromise) {
        playPromise.catch(() => {});
      }
    }

    pauseVideo() {
      if (this.video && !this.video.paused) {
        this.video.pause();
      }
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.pauseVideo();
      } else if (this.isNearViewport) {
        this.loadVideo();
        this.playVideo();
      }
    }
  }

  customElements.define('deferred-media-video', DeferredMediaVideo);
}
